<template>
    <v-container>
        <v-card>
            <v-toolbar dense dark elevation="0">
                <v-toolbar-title>Calendar of reports</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-select
                        v-model="yearSelected"
                        :items="years"
                    ></v-select>
                </v-toolbar-items>
            </v-toolbar>
            <calendar-report :year.sync="yearSelected" style="max-height:250px"></calendar-report>
        </v-card>
    </v-container>
</template>
<script>
import CalendarReport from "@/components/plots/CalendarReport.vue"
export default {
    name: "CalendarCard",
    components: {
        CalendarReport
    },
    data(){
        return {
            yearSelected: new Date().getFullYear(),
            years: this.listOfYears(),
        }
    },
    methods: {
        listOfYears(){
            var years = []
            let end = new Date().getFullYear();
            for (var y = 2019; y <= end; y++) {
                years.push(y)
            }
            return years;
        }
    }
}
</script>